module.exports = __webpack_public_path__ + "img/6.3f4b7fc8.jpg";